define('mailsRouter',[
  'app',
  'require',
  'module',
  'marionette',
  'underscore',
  'backbone',
  'itemPagesNameMixin',
  'contentShowController',
  'mailsMailView'
], function (
  App,
  require,
  module,
  Marionette,
  _,
  Backbone,
  ItemPagesNameMixin,
  ContentShowController,
  MailView
) {
  'use strict';

  var MailsRouter = Marionette.AppRouter.extend({
    appRoutes: {
      'mails': 'showList',
      'mails/:from': 'showList',
      'mails/:from/email/:emailId': 'showEmailDetailPopup',
      'mails/:from/:folder': 'showList'
    }
  });

  var API = {

    showEmailDetailPopup: function (from, emailId) {
      ContentShowController.showContent().done(function () {
        MailView.prototype.open(new Backbone.Model({id: emailId}), from);
      });
    },

    showList: function (from, folder) {
      require([
        'mailsView',
        'contentShowController'
      ], function (MailsView,
                   ContentShowController) {
        ContentShowController.showContent().done(function () {
          this.mailsView = new MailsView({
            from: from,
            folder: folder
          });
          App.regions.getRegion('main').currentView.getRegion('content').show(this.mailsView);
          //App.startSubModule('adminMain');
          App.execute('set:active:nav:item', ItemPagesNameMixin.MAILS);
        });
      });
    }
  };

  App.on('before:start', function () {
    new MailsRouter({
      controller: API
    });
  });

  module.exports = MailsRouter;
});

